module.exports = __webpack_public_path__ + "static/media/andrew.1802bd81.jpeg";